import type { IUserKeywordGroup, IKeywordGroup } from "../keywordGroups.types";

const camelCase = (str: string): string => {
    return str
        .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
            return index === 0 ? word.toLowerCase() : word.toUpperCase();
        })
        .replace(/\s+/g, "");
};

export const keywordGroupsTransforms = {
    toDropDown: (groups: IUserKeywordGroup[] = []): IKeywordGroup[] => {
        return groups
            .map(keywordGroupsTransforms.toDropDownGroup)
            .sort((a, b) => a.text.toLowerCase().localeCompare(b.text.toLowerCase()));
    },

    findGroupById: (groups: IUserKeywordGroup[], groupId: string): IUserKeywordGroup | undefined => {
        if (!groupId) {
            return undefined;
        }
        return groups.find(({ Id }) => Id === groupId);
    },

    isKeywordGroup: (keyword: string): boolean => {
        return keyword?.startsWith(KEYWORD_GROUP_PREFIX) ?? false;
    },

    getGroupIdFromUrlParam: (keyword: string): string => {
        return keyword.startsWith(KEYWORD_GROUP_PREFIX) ? keyword.substring(1) : keyword;
    },

    toDropDownGroup: (group: IUserKeywordGroup): IKeywordGroup => {
        const { sharedWithAccounts = [], sharedWithUsers = [] } = group;
        return {
            text: group.Name,
            icon: "sw-icon-folder",
            id: (group.Id || group.Name).toString(),
            domains: group.Keywords || [],
            shared: sharedWithAccounts.length > 0 || sharedWithUsers.length > 0,
            sharedWithAccounts: sharedWithAccounts,
            sharedWithUsers: sharedWithUsers,
            userId: group.UserId || "",
        };
    },

    adaptGroupDataForShareModal: (group: IUserKeywordGroup & { id?: string }, groups: IUserKeywordGroup[]): any => {
        const groupOnService = keywordGroupsTransforms.findGroupById(groups, group.id || group.Id);
        if (!groupOnService) {
            return group;
        }

        const groupForShare = {
            ...group,
            ...Object.fromEntries(
                Object.entries(groupOnService).map(([key, value]) => {
                    return [camelCase(key), value];
                }),
            ),
        };

        return groupForShare;
    },
};

export const KEYWORD_GROUP_PREFIX = "*" as const;
export const KEYWORD_GROUPS_ENDPOINT = "/api/userdata/KeywordGroups" as const;
